import React from "react";
import { SiGooglesheets, SiPostgresql, SiSqlite } from "react-icons/si";
import { easyonDatabases } from "../../data/easyonPageContent";
import { EasyonDatabasePlatformsVisual } from "./EasyonDatabasePlatformsVisual";
import { EasyonReveal, EasyonStagger, EasyonStaggerItem } from "./EasyonMotion";

const dbIcons = {
    postgresql: SiPostgresql,
    sheets: SiGooglesheets,
    sqlite: SiSqlite,
};

export const EasyonDatabaseSection = () => (
    <section className="eo-database">
        <div className="eo-container">
            <EasyonReveal className="eo-database__header">
                <span className="eo-eyebrow">Database Support</span>
                <h2 className="eo-h2">Flexible Data Architecture</h2>
                <p className="eo-lead">
                    Connect EasyOn to the database that fits your business — from enterprise PostgreSQL to
                    lightweight SQLite.
                </p>
            </EasyonReveal>

            <div className="eo-database__layout">
                <EasyonStagger className="eo-database__cards">
                    {easyonDatabases.map((db) => {
                        const Icon = dbIcons[db.iconKey];
                        return (
                            <EasyonStaggerItem key={db.name}>
                                <div className="eo-db-card">
                                    <div className="eo-db-card__icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3>{db.name}</h3>
                                    <p>{db.description}</p>
                                </div>
                            </EasyonStaggerItem>
                        );
                    })}
                </EasyonStagger>

                <EasyonReveal className="eo-database__visual" delay={0.15}>
                    <EasyonDatabasePlatformsVisual />
                </EasyonReveal>
            </div>
        </div>
    </section>
);
